// extracted by mini-css-extract-plugin
export default {"WorldMapEdit":"WorldMapEdit_WorldMapEdit__T+u3u","wrapperMapRef":"WorldMapEdit_wrapperMapRef__qUIzc","w1260":"WorldMapEdit_w1260__6SjLC"};